/**
 * Application wide constants
 */

// Locale
export const DOCUMENT_LANG = document.documentElement.lang || 'nl';

// Bootstrap breakpoints
export const breakpoints = {
    sm: 0,
    md: 600,
    lg: 1280,
};

// Grid gutter width
export const gridGutterWidth = Number(getComputedStyle(document.documentElement).getPropertyValue('--dw-gutter-x').replace('rem', '')) * 16;

function calculateSpaceBetween() {
    const rootStyles = getComputedStyle(document.documentElement);
    const scrollbarWidth = parseFloat(rootStyles.getPropertyValue('--scrollbar-width'));
    const targetScreenSize = parseFloat(rootStyles.getPropertyValue('--target-screen-size'));

    const viewportWidth = window.innerWidth;
    const maxContentWidth = 1920;

    const calculatedWidth = Math.min(viewportWidth - scrollbarWidth, maxContentWidth);

    const targetPixelSize = calculatedWidth / targetScreenSize;

    return targetPixelSize;
}

const gridGutter = getComputedStyle(document.documentElement).getPropertyValue('--grid-gutter');
let gutter;

if (gridGutter.includes('calc')) {
    gutter = gridGutter.replace('calc(', '').replace(' * 0.5)', '');
} else {
    gutter = gridGutter;
}

export const FD = {
    targetPixelSize: calculateSpaceBetween(),
    gridGutter: eval(gutter.replace('calc(', '').replace(')', '')),
    designFactor: getComputedStyle(document.documentElement).getPropertyValue('--design-factor'),
};
